"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COOKIE_KEY_COOKIES_ACCEPTED = exports.COOKIE_KEY_COOKIES_POPUP_DISMISSED = exports.COOKIE_KEY_LOCALE = exports.UNRESOLVED_STRING = exports.LOCALES_LANGUAGE_ONLY_TO_NORMAL = exports.LOCALES_LOWER_TO_NORMAL = exports.ALL_LOCALES = exports.DEFAULT_AVAILABLE_LOCALES = exports.LOCALE_ARRAY = exports.DEFAULT_COOKIE_ICON_RIGHT = exports.DEFAULT_COOKIE_ICON_LEFT = exports.DEFAULT_COOKIE_POLICY_URL = exports.DEFAULT_SNAP_COM_DOMAIN = exports.DEFAULT_LOCALE = exports.DEFAULT_DOMAIN = void 0;
var DEFAULT_DOMAIN = 'snapchat.com';
exports.DEFAULT_DOMAIN = DEFAULT_DOMAIN;
var DEFAULT_LOCALE = 'en-US';
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
var DEFAULT_SNAP_COM_DOMAIN = 'snap.com';
exports.DEFAULT_SNAP_COM_DOMAIN = DEFAULT_SNAP_COM_DOMAIN;
var DEFAULT_COOKIE_POLICY_URL = 'https://www.snap.com/cookie-policy/';
exports.DEFAULT_COOKIE_POLICY_URL = DEFAULT_COOKIE_POLICY_URL;
var DEFAULT_COOKIE_ICON_LEFT = 'https://www.snapchat.com/home/cookie-1.svg';
exports.DEFAULT_COOKIE_ICON_LEFT = DEFAULT_COOKIE_ICON_LEFT;
var DEFAULT_COOKIE_ICON_RIGHT = 'https://www.snapchat.com/home/cookie-2.svg'; // If the same 2 letter language code is shared, make sure the default language is the last one.
// For example, `en-US` should be after `en-GB` because `en-US` is the default `en`.

exports.DEFAULT_COOKIE_ICON_RIGHT = DEFAULT_COOKIE_ICON_RIGHT;
var LOCALE_ARRAY = {
  ar: {
    name: 'العَرَبِية',
    lang: 'ar',
    dir: 'rtl'
  },
  'bn-BD': {
    name: 'বাংলা(বাংলাদেশ)',
    lang: 'bn-BD',
    dir: 'ltr'
  },
  'bn-IN': {
    name: 'বাংলা (ভারত)',
    lang: 'bn-IN',
    dir: 'ltr'
  },
  'id-ID': {
    name: 'Bahasa Indonesia',
    lang: 'id-ID',
    dir: 'ltr'
  },
  'da-DK': {
    name: 'Dansk',
    lang: 'da-DK',
    dir: 'ltr'
  },
  'de-DE': {
    name: 'Deutsch',
    lang: 'de-DE',
    dir: 'ltr'
  },
  'el-GR': {
    name: 'Ελληνικά',
    lang: 'el-GR',
    dir: 'ltr'
  },
  'en-GB': {
    name: 'English (UK)',
    lang: 'en-GB',
    dir: 'ltr'
  },
  'en-US': {
    name: 'English (US)',
    lang: 'en-US',
    dir: 'ltr'
  },
  es: {
    name: 'Español',
    lang: 'es',
    dir: 'ltr'
  },
  'es-AR': {
    name: 'Español (Argentine)',
    lang: 'es-AR',
    dir: 'ltr'
  },
  'es-ES': {
    name: 'Español (España)',
    lang: 'es-ES',
    dir: 'ltr'
  },
  'es-MX': {
    name: 'Español (México)',
    lang: 'es-MX',
    dir: 'ltr'
  },
  'fi-FI': {
    name: 'Suomi',
    lang: 'fi-FI',
    dir: 'ltr'
  },
  'fil-PH': {
    name: 'Filipino',
    lang: 'fil-PH',
    dir: 'ltr'
  },
  'fr-FR': {
    name: 'Français',
    lang: 'fr-FR',
    dir: 'ltr'
  },
  'gu-IN': {
    name: 'ગુજરાતી',
    lang: 'gu-IN',
    dir: 'ltr'
  },
  'hi-IN': {
    name: 'हिंदी',
    lang: 'hi-IN',
    dir: 'ltr'
  },
  'it-IT': {
    name: 'Italiano',
    lang: 'it-IT',
    dir: 'ltr'
  },
  'ja-JP': {
    name: '日本語',
    lang: 'ja-JP',
    dir: 'ltr'
  },
  'kn-IN': {
    name: 'ಕನ್ನಡ (India)',
    lang: 'kn-IN',
    dir: 'ltr'
  },
  'ko-KR': {
    name: '한국어',
    lang: 'ko-KR',
    dir: 'ltr'
  },
  'ml-IN': {
    name: 'മലയാളം',
    lang: 'ml-IN',
    dir: 'ltr'
  },
  'mr-IN': {
    name: 'मराठी',
    lang: 'mr-IN',
    dir: 'ltr'
  },
  'ms-MY': {
    name: 'Bahasa Melayu',
    lang: 'ms-MY',
    dir: 'ltr'
  },
  'nl-NL': {
    name: 'Nederlands',
    lang: 'nl-NL',
    dir: 'ltr'
  },
  'nb-NO': {
    name: 'Norsk',
    lang: 'nb-NO',
    dir: 'ltr'
  },
  pa: {
    name: 'ਪੰਜਾਬੀ',
    lang: 'pa',
    dir: 'ltr'
  },
  'pl-PL': {
    name: 'Polski',
    lang: 'pl-PL',
    dir: 'ltr'
  },
  'pt-BR': {
    name: 'Português (Brasil)',
    lang: 'pt-BR',
    dir: 'ltr'
  },
  'pt-PT': {
    name: 'Português (Portugal)',
    lang: 'pt-PT',
    dir: 'ltr'
  },
  'ro-RO': {
    name: 'Română',
    lang: 'ro-RO',
    dir: 'ltr'
  },
  'ru-RU': {
    name: 'Русский',
    lang: 'ru-RU',
    dir: 'ltr'
  },
  'sv-SE': {
    name: 'Svenska',
    lang: 'sv-SE',
    dir: 'ltr'
  },
  'ta-IN': {
    name: 'தமிழ்',
    lang: 'ta-IN',
    dir: 'ltr'
  },
  'te-IN': {
    name: 'తెలుగు',
    lang: 'te-IN',
    dir: 'ltr'
  },
  'th-TH': {
    name: 'ภาษาไทย (ประเทศไทย)',
    lang: 'th-TH',
    dir: 'ltr'
  },
  'tr-TR': {
    name: 'Türkçe',
    lang: 'tr-TR',
    dir: 'ltr'
  },
  'ur-PK': {
    name: 'اردو',
    lang: 'ur-PK',
    dir: 'rtl'
  },
  'vi-VN': {
    name: 'Tiếng Việt',
    lang: 'vi-VN',
    dir: 'ltr'
  },
  // zh-CN = zh-Hans
  'zh-CN': {
    name: '中文（简体）',
    lang: 'zh-CN',
    dir: 'ltr'
  },
  'zh-Hans': {
    name: '中文（简体）',
    lang: 'zh-Hans',
    dir: 'ltr'
  },
  // zh-TW = zh-Hant
  'zh-TW': {
    name: '中文（繁體）',
    lang: 'zh-TW',
    dir: 'ltr'
  },
  'zh-Hant': {
    name: '中文（繁體）',
    lang: 'zh-Hant',
    dir: 'ltr'
  }
};
exports.LOCALE_ARRAY = LOCALE_ARRAY;
var DEFAULT_AVAILABLE_LOCALES = ['da-DK', 'de-DE', 'en-US', 'en-GB', 'es', 'fr-FR', 'it-IT', 'ja-JP', 'nl-NL', 'nb-NO', 'pt-BR', 'fi-FI', 'sv-SE'];
exports.DEFAULT_AVAILABLE_LOCALES = DEFAULT_AVAILABLE_LOCALES;
var ALL_LOCALES = {};
exports.ALL_LOCALES = ALL_LOCALES;
var LOCALES_LOWER_TO_NORMAL = {};
exports.LOCALES_LOWER_TO_NORMAL = LOCALES_LOWER_TO_NORMAL;
var LOCALES_LANGUAGE_ONLY_TO_NORMAL = {};
exports.LOCALES_LANGUAGE_ONLY_TO_NORMAL = LOCALES_LANGUAGE_ONLY_TO_NORMAL;
var keys = Object.keys(LOCALE_ARRAY);

for (var i = 0, length = keys.length; i < length; i++) {
  var _LOCALE_ARRAY$keys$i = LOCALE_ARRAY[keys[i]],
      lang = _LOCALE_ARRAY$keys$i.lang,
      name = _LOCALE_ARRAY$keys$i.name;
  var lowerCaseKey = lang.toLowerCase();
  var languageOnlyKey = lang.substring(0, 2).toLowerCase();
  ALL_LOCALES[lang] = name;
  LOCALES_LOWER_TO_NORMAL[lowerCaseKey] = lang;
  LOCALES_LANGUAGE_ONLY_TO_NORMAL[languageOnlyKey] = lang;
}

var UNRESOLVED_STRING = '???';
exports.UNRESOLVED_STRING = UNRESOLVED_STRING;
var COOKIE_KEY_LOCALE = 'sc-language';
exports.COOKIE_KEY_LOCALE = COOKIE_KEY_LOCALE;
var COOKIE_KEY_COOKIES_POPUP_DISMISSED = 'sc-cookies-popup-dismissed';
exports.COOKIE_KEY_COOKIES_POPUP_DISMISSED = COOKIE_KEY_COOKIES_POPUP_DISMISSED;
var COOKIE_KEY_COOKIES_ACCEPTED = 'sc-cookies-accepted';
exports.COOKIE_KEY_COOKIES_ACCEPTED = COOKIE_KEY_COOKIES_ACCEPTED;